import { ChartOptions } from "chart.js";

export const subscriptionChartOptions: ChartOptions = {
    legend: {
        display: false,
    },
    tooltips: {
        enabled: false,
    },
    elements: {
        arc: {
            borderWidth: 0,
            backgroundColor: [
                "rgba(226, 99, 228)",   // lavender
                "rgba(205, 231, 42)",   // pear
                "rgba(100, 88, 239)",   // royal blue
                "rgba(41, 208, 219)",   // scooter
                "rgba(212, 29, 62)",    // error
                "rgba(246, 188, 118)",  // rajah
                "rgba(234, 119, 107)",  // terracotta
                "rgba(132, 141, 39)",   // primary
            ],
        },
    },
    responsive: false,
    cutoutPercentage: 75,
};

export const regisrationChartOptions: ChartOptions = {
    legend: {
        display: false,
    },
    tooltips: {
        enabled: false,
    },
    elements: {
        arc: {
            borderWidth: 0,
            backgroundColor: ["#EA776B", "#6458EF", "#CDE72A", "#848D27"],
        },
    },
    responsive: false,
    cutoutPercentage: 75,
};
